import { isPasskeyCancelled, supabase } from '@/lib/supabase'
import { useAuthPreferenceStore } from '@/store/useAuthPreferenceStore'

export type PasskeyRegisterResult = 'registered' | 'already-registered' | 'cancelled' | 'failed'

/**
 * この端末でパスキーを登録する（Face ID 等の確認が出る）
 *
 * 登録できた（または登録済みだった）ら、この端末のサインイン方法をパスキーとして覚える。
 */
export const registerPasskeyOnThisDevice = async (): Promise<PasskeyRegisterResult> => {
  const { error } = await supabase.auth.registerPasskey()
  if (!error) {
    useAuthPreferenceStore.getState().setLastSignInMethod('passkey')
    return 'registered'
  }
  if (isPasskeyCancelled(error)) return 'cancelled'
  if ('code' in error && error.code === 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED') {
    useAuthPreferenceStore.getState().setLastSignInMethod('passkey')
    return 'already-registered'
  }
  console.error('[Passkey] Failed to register passkey:', error)
  return 'failed'
}
